import {useGetSpeechModelListe} from "../../client/hooks";
import {useQuery} from "react-query";
import {SpeechModelListe} from "../../api";

type SpeechModelOption = { id: string; name: string };

export function useSpeechModelHandling(speechModel?: string) {
    const { data: speechModelListe } = useSpeechModelListeQuery();
    const speechModelOptions = speechModelListe?.speechModels ?? [];
    const selectedSpeechModel = speechModel
        ? (speechModelOptions.find((option: SpeechModelOption) => option.id === speechModel) ?? { id: speechModel, name: speechModel })
        : null;

    return { speechModelOptions, selectedSpeechModel };
}

function useSpeechModelListeQuery() {
    const getSpeechModelListe = useGetSpeechModelListe();

    return useQuery<SpeechModelListe>({
        queryKey: ["speechModelListe"],
        queryFn: getSpeechModelListe,
    });
}
